module.exports = __webpack_public_path__ + "img/phoneBanner5.41b90596.jpg";